import axios from "axios";
import { message } from 'antd';
import UserStore from '../stores/UserStore'
const url = process.env.REACT_APP_BACKEND_URL;

export async function makeWager(
    authToken,
    userId,
    bytes32Id,
    eventId,  
    value,    
    makerChoice,
    isPropWager,
    originalEventId   
) {
    return axios.post(url + "/poolWagers?userId=" + userId, {
        bytes32Id,
        eventId,     
        value,
        maker: userId,       
        makerChoice,     
        isPropWager,
        originalEventId      
    }, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        })
        .then(function (response) {
            message.info("Success, wager made!");
            console.log(response);
        })
        .catch(function (error) {
            message.error("Error making wager.");
            console.log(error);
        });
}


export async function getAllUserWagers(userId) {
    axios({
        method: 'get',
        url: url + "/poolWagers?userId=" + userId,
    }).then(res => {
        UserStore.updatePoolBets(res.data);
             
        return res.data;
    });
}

export async function claimWin(wagerId, userId) {
    axios({
        method: 'put',
        url: url + "/poolWagers/claimWin?wagerId=" + wagerId,
        data: {
            userId: userId
        }
    }).then(res => {
        UserStore.updatePoolBets(res.data);
             
        return res.data;
    });
}


export async function claimRefund(wagerId, userId) {
    axios({
        method: 'put',
        url: url + "/poolWagers/claimRefund?wagerId=" + wagerId,
        data: {
            userId: userId
        }
    }).then(res => {
        UserStore.updatePoolBets(res.data);
             
        return res.data;
    });
}





// WEBPACK FOOTER //
// ./src/api-calls/poolWagers.js